import { useState } from 'react';

import { useNotificationStore } from '../../../../utils/NotificationStore';
import { copySuccess } from '../../utils/CandidateHelper';

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

function useCopyToClipboard(): [CopiedValue, CopyFn] {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  function handler(event, text) {
    event.clipboardData.setData('text/plain', text);
    event.preventDefault();
    document.removeEventListener('copy', (event) => handler(event, text), true);
  }

  const copy: CopyFn = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      setNotification(copySuccess());
      return true;
    } catch (error) {
      document.addEventListener('copy', (event) => handler(event, text), true);
      document.execCommand('copy');
      setCopiedText(text);
      setNotification(copySuccess());
      return true;
    }
  };

  return [copiedText, copy];
}

export default useCopyToClipboard;
